import * as ApiInstance from './apiInstance';
import * as ApiInstanceField from './apiInstanceField';
import * as CanonicalField from './canonicalField';
import * as CanonicalFieldType from './canonicalFieldType';
import * as CopilotSession from './copilot/session';
import * as Credential from './credential';
import * as CredentialCheckout from './credentialCheckout';
import * as EhrInstance from './ehrInstance';
import * as EhrInstanceAlert from './ehrInstanceAlert';
import * as EhrInstanceDowntime from './ehrInstanceDowntime';
import * as EhrInstanceField from './ehrInstanceField';
import * as InstanceField from './instanceField';
import * as Job from './job';
import * as JobConfig from './jobConfig';
import * as ManualJob from './manualJob';
import * as PracticeConfig from './practiceConfig';
import * as PracticeConfigApiInstance from './practiceConfig/apiInstance';
import * as PracticeConfigEhrInstance from './practiceConfig/ehrInstance';

export {
  ApiInstance,
  ApiInstanceField,
  CanonicalField,
  CanonicalFieldType,
  CopilotSession,
  Credential,
  CredentialCheckout,
  EhrInstance,
  EhrInstanceAlert,
  EhrInstanceDowntime,
  EhrInstanceField,
  InstanceField,
  Job,
  JobConfig,
  ManualJob,
  PracticeConfig,
  PracticeConfigApiInstance,
  PracticeConfigEhrInstance,
};

export enum Endpoint {
  GetCalendarSync = 'getCalendarSync',
  GetAllergies = 'getAllergies',
  PutAllergies = 'putAllergies',
  DeleteAppointments = 'deleteAppointments',
  GetAppointments = 'getAppointments',
  PatchAppointments = 'patchAppointments',
  PostAppointments = 'postAppointments',
  GetBinaries = 'getBinaries',
  GetCommon = 'getCommon',
  PatchCommon = 'patchCommon',
  PostCommon = 'postCommon',
  PutCommon = 'putCommon',
  GetConditions = 'getConditions',
  PostConditions = 'postConditions',
  GetCoverages = 'getCoverages',
  GetDocuments = 'getDocuments',
  PostDocuments = 'postDocuments',
  GetDiagnosticReports = 'getDiagnosticReports',
  GetEncounters = 'getEncounters',
  GetFamilyHistories = 'getFamilyHistories',
  PutFamilyHistories = 'putFamilyHistories',
  PostFlowsheets = 'postFlowsheets',
  GetLabValues = 'getLabValues',
  PostGeneralComments = 'postGeneralComments',
  GetGuarantors = 'getGuarantors',
  PostGuarantors = 'postGuarantors',
  GetLists = 'getLists',
  GetMedicalHistories = 'getMedicalHistories',
  GetMedicationRequests = 'getMedicationRequests',
  PatchMedicationRequests = 'patchMedicationRequests',
  GetPatients = 'getPatients',
  PatchPatients = 'patchPatients',
  PostPatients = 'postPatients',
  GetPayments = 'getPayments',
  PostPayments = 'postPayments',
  GetPharmacies = 'getPharmacies',
  PostPharmacies = 'postPharmacies',
  GetPractitioners = 'getPractitioners',
  PostPractitioners = 'postPractitioners',
  PostSmartdataElements = 'postSmartdataElements',
  GetSocialHistories = 'getSocialHistories',
  GetSurgicalHistories = 'getSurgicalHistories',
  PostSurgicalHistories = 'postSurgicalHistories',
  GetUploads = 'getUploads',
  GetCareTeam = 'getCareTeam',
}
